import { render, staticRenderFns } from "./AddYear.vue?vue&type=template&id=5ec4992b&scoped=true"
import script from "./AddYear.vue?vue&type=script&lang=js"
export * from "./AddYear.vue?vue&type=script&lang=js"
import style0 from "./AddYear.vue?vue&type=style&index=0&id=5ec4992b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec4992b",
  null
  
)

export default component.exports